<template>
	<div class="scenariomakeup">
		<Loading msg="loading" v-if="!isload" />
		<div class="guide_inner" v-else>
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
                <div class="inner_up">
                    <h1 class="guide_title">每天化妆的情况下怎么护肤</h1>
                    <ul class="detail_menu">
                        <li class="menu_item" :class="focused_idx == 0 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:599 }),{is_access:true,reportEvent_page_id:599,reportEvent_page_name:'经常化妆 - 卸妆方式',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'}));changeFocusedTab(0);" ref="focused_item_0">卸妆方式</li>
                        <li class="menu_item" :class="focused_idx == 1 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:600 }),{is_access:true,reportEvent_page_id:600,reportEvent_page_name:'经常化妆 - 注重保湿',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'}));changeFocusedTab(1);" ref="focused_item_1">注重保湿</li>
                        <li class="menu_item" :class="focused_idx == 2 ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:601 }),{is_access:true,reportEvent_page_id:601,reportEvent_page_name:'经常化妆 - 更多建议',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'}));changeFocusedTab(2);" ref="focused_item_2">更多建议</li>
                        <span class="bg_div" :style="'width:' + focused_width + 'px;left:' + focused_left + 'px'"></span>
                    </ul>
                </div>
                <!-- 卸妆方式 -->
                <div class="inner_down inner_down_first" v-if="focused_idx == 0">
                    <div class="inner_down_title">不同情况下如何卸妆?</div>
                    <!-- 淡妆 -->
                    <div class="makeup_item">
                        <div class="makeup_item_title"><span class="makeup_item_title_text">淡妆</span></div>
                        <p class="makeup_item_text">即只有简单的底妆、遮瑕，没有使用防水性彩妆。<br>防水型防晒可以仿照淡妆的清洁方式。</p>
                        <div class="makeup_item_summary">清洁力需求:一般</div>
                        <div class="makeup_item_summary">清洁产品种类推荐:卸妆水/啫喱、卸妆乳、洗卸合一洗面奶</div>
                        <div class="makeup_item_check_btn"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:602 }),{is_access:true,reportEvent_page_id:602,reportEvent_page_name:'经常化妆 - 卸妆方式 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),show_oth_pro=true,filterMakeupPro('remover_water')">卸妆产品推荐</span></div>
                    </div>
                    <!-- 浓妆 -->
                    <div class="makeup_item">
                        <div class="makeup_item_title"><span class="makeup_item_title_text">浓妆</span></div>
                        <p class="makeup_item_text">即全套妆容，包括底妆、遮瑕、高光修容、腮红、眼妆等等，特别是用了防水性、不易脱落的彩妆。</p>
                        <div class="makeup_item_summary">清洁力需求:较高</div>
                        <div class="makeup_item_summary">清洁产品种类推荐:卸妆油、卸妆膏</div>
                        <div class="makeup_item_check_btn"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:602 }),{is_access:true,reportEvent_page_id:602,reportEvent_page_name:'经常化妆 - 卸妆方式 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),show_oth_pro=true,filterMakeupPro('remover_oil')">卸妆产品推荐</span></div>
                    </div>
                    <!-- 眼唇妆 -->
                    <div class="makeup_item">
                        <div class="makeup_item_title"><span class="makeup_item_title_text">眼唇妆</span> <span class="makeup_item_title_mark">特殊</span></div>
                        <p class="makeup_item_text">眼唇妆的防水性比较好，对卸妆力要求比较高，最好用专门的眼唇卸妆产品。</p>
                        <div class="makeup_item_summary">清洁力需求:较高</div>
                        <div class="makeup_item_summary">清洁产品种类推荐:眼唇卸妆液</div>
                        <div class="makeup_item_check_btn"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:602 }),{is_access:true,reportEvent_page_id:602,reportEvent_page_name:'经常化妆 - 卸妆方式 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),show_oth_pro=true,filterMakeupPro('remover_eye')">卸妆产品推荐</span></div>
                    </div>
                    <!-- 敏感肌卸妆 -->
                    <div class="makeup_item">
                        <div class="makeup_item_title"><span class="makeup_item_title_text">敏感肌卸妆</span> <span class="makeup_item_title_mark">特殊</span></div>
                        <p class="makeup_item_text">轻度敏感的情况下，建议化淡妆，卸妆时要减少卸妆产品在脸上的停留时间，以及减少对皮肤的按摩和擦拭。重度敏感的情况下，建议先暂停化妆。</p>
                        <div class="makeup_item_result_part">
                          <div class="makeup_item_result_part_title">我的敏感风险:{{makeupdata.sensi.sensi}}</div>
                          <div class="makeup_item_result_part_desc" v-if="makeupdata.sensi.dqmtype.length>0"><span>现状结果-屏障:{{makeupdata.sensi.dqmtype}}</span></div>
                          <div class="makeup_item_result_part_desc" v-if="makeupdata.sensi.survey_3qs_desc.length>0"><span>敏感自述:{{makeupdata.sensi.survey_3qs_desc}}</span></div>
                        </div>
                        <div class="makeup_item_summary">清洁力需求:一般</div>
                        <div class="makeup_item_summary">清洁产品种类推荐:卸妆水，洗面奶(洗卸合一)</div>
                        <div class="makeup_item_check_btn"><span @click="($parent.trackLog((actParams = { query: $route.query, pageid:602 }),{is_access:true,reportEvent_page_id:602,reportEvent_page_name:'经常化妆 - 卸妆方式 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),show_oth_pro=true,filterMakeupPro('remover_sensi')">卸妆产品推荐</span></div>
                    </div>

                    <!-- 相关问答 -->
                    <ul class="makeup_related_qus_ul">
                      <li class="makeup_related_qus"><span @click="show_layer=true,show_makeup_remover=true">卸妆产品的种类有哪些？</span></li>
                      <li class="makeup_related_qus"><span @click="show_layer=true,show_reclean=true">是否需要二次清洁？</span></li>
                      <li class="makeup_related_qus"><span @click="show_layer=true,show_prevent_acne=true">如何避免卸妆致痘？</span></li>
                    </ul>

                   <transition name="fade">
                      <div class="makeup_remover_desc_layer" v-if="show_layer">
                         <!-- 卸妆产品种类弹窗 -->
                        <div class="makeup_remover_desc_layer_inner" v-show="show_makeup_remover">
                          <img src="../assets/images/close_btn.svg" class="makeup_remover_desc_close_btn" alt="" @click="show_layer=false,show_makeup_remover=false">
                          <div class="makeup_remover_desc_layer_title"><span>卸妆产品的种类有哪些?</span></div>
                          <div class="makeup_remover_desc_layer_info">
                            <div class="makeup_layer_desc_layer_info_title">
                              <span class="makeup_layer_info_title_name">卸妆水/啫喱</span>
                              <span class="makeup_layer_info_title_effect">清洁力:较弱</span>
                            </div>
                            <p class="makeup_layer_desc_layer_info_explain">水性的卸妆产品，主要成分是水和表面活性剂。卸妆水通常比较温和，但是清洁力有限，不能卸除防水性的彩妆。另外，由于需要用棉片配合擦拭皮肤，对角质层会带来一定损伤。</p>
                            <div class="makeup_layer_desc_layer_info_title">
                              <span class="makeup_layer_info_title_name">洗卸合一洗面奶</span>
                              <span class="makeup_layer_info_title_effect">清洁力:中等</span>
                            </div>
                            <p class="makeup_layer_desc_layer_info_explain">清洁力较强的洗面奶可以直接洗去淡妆，加了皂基的洗面奶清洁力比卸妆水更高。</p>
                            <div class="makeup_layer_desc_layer_info_title">
                              <span class="makeup_layer_info_title_name">卸妆乳</span>
                              <span class="makeup_layer_info_title_effect">清洁力:中等</span>
                            </div>
                            <p class="makeup_layer_desc_layer_info_explain">卸妆乳是介于卸妆水和卸妆油之间的一个种类，卸妆力适中，肤感比卸妆油更润一些，可以用清水冲洗掉，是比较温和的类型。</p>
                            <div class="makeup_layer_desc_layer_info_title">
                              <span class="makeup_layer_info_title_name">卸妆膏</span>
                              <span class="makeup_layer_info_title_effect">清洁力:较强</span>
                            </div>
                            <p class="makeup_layer_desc_layer_info_explain">油膏或蜡状的卸妆产品，使用前需要先在手心捂热，上脸后变为油状，卸妆力比较好。同时肤感较润，不会像卸妆油一样洗后拔干。</p>
                            <div class="makeup_layer_desc_layer_info_title">
                              <span class="makeup_layer_info_title_name">卸妆油</span>
                              <span class="makeup_layer_info_title_effect">清洁力:强</span>
                            </div>
                            <p class="makeup_layer_desc_layer_info_explain">油性的卸妆产品，通过“油”和表面活性剂的双重作用，能达到很好的卸妆效果。但是卸妆油的肤感通常不太好，会感到油腻厚重、残留感重。</p>
                            <div class="makeup_layer_desc_layer_info_title">
                              <span class="makeup_layer_info_title_name">眼唇卸妆液</span>
                              <span class="makeup_layer_info_title_effect">清洁力:强</span>
                            </div>
                            <p class="makeup_layer_desc_layer_info_explain">大多数是水油分离型产品，使用前需要混合均匀，专门用于卸除眼妆和唇妆。</p>

                          </div>

                        </div>

                        <!-- 是否需要二次清洁弹窗 -->
                        <div class="makeup_reclean_layer_inner" v-show="show_reclean">
                          <img src="../assets/images/close_btn.svg" class="makeup_reclean_layer_close_btn" alt="" @click="show_layer=false,show_reclean=false">
                          <div class="makeup_reclean_layer_title"><span>是否需要二次清洁？</span></div>
                          <p class="makeup_reclean_layer_text">二次清洁是指用完卸妆产品后，再用洗面奶等产品进行清洁。二次清洁不是必须的，取决于卸妆产品的特点和个人肤质。<br>1、需要二次清洁的情况：卸妆产品残留感较重（比如卸妆油、卸妆膏）、自身容易长痘。这种情况下，卸完妆后要用温和的洗面奶清洁残留的卸妆产品，防止致痘。<br>2、无需二次清洁的情况：卸妆产品容易冲洗（比如卸妆水）、自身不容易长痘、干性皮肤。这种情况下，卸完妆后用清水冲洗即可，不要叠加清洁产品。</p>
                        </div>

                        <!-- 如何比卖你卸妆致痘弹窗 -->
                        <div class="makeup_prevent_acne_layer_inner" v-show="show_prevent_acne">
                          <img src="../assets/images/close_btn.svg" class="makeup_prevent_acne_layer_close_btn" alt="" @click="show_layer=false,show_prevent_acne=false">
                          <div class="makeup_prevent_acne_layer_title"><span>如何避免卸妆致痘？</span></div>
                          <p class="makeup_prevent_acne_layer_text">1、不要过度清洁：反复清洁、大力清洁都会破坏皮肤屏障，皮肤极度干燥的情况下容易引起角化异常，形成闭口；如果清洁完使用了滋润的护肤品，护肤品中的致痘成分也更容易进入皮肤深层，引起痘痘。所以清洁要适度。<br>2、充分乳化：使用卸妆油时充分乳化，不要着急用水冲掉，避免彩妆残留。<br>3、选择肤感清爽的卸妆产品：油皮如果没有化浓妆，尽量选择肤感清爽的产品，例如卸妆水。</p>
                        </div>


                      </div>
                  </transition>
                      <!-- 其他产品列表弹窗 -->
                    <transition name="fade">
                        <div class="oth_rec_layer" v-if="show_oth_pro">
                            <div class="layer_inner">
                                <img src="../assets/images/close_btn.svg" class="close_icon" alt="" @click="show_oth_pro =false">
                                <div class="layer_title">卸妆产品</div>
                                <ul class="layer_pro_list">
                                <li class="layer_pro" v-for="(remover_item,remover_idx) in makeup_remover_pro" :key="remover_idx">
                                    <div class="layer_pro_check_btn" v-if="remover_item.uniskin_goods_id" @click="$parent.goMallDetail(remover_item.uniskin_goods_id)">
                                        <span>去购买</span>
                                        <img src="../assets/images/arrow_right_d.svg" class="layer_pro_check_icon" alt="">
                                    </div>
                                    <img v-lazy="remover_item.img" :key="remover_item.img" class="pro_pic" alt="">
                                    <div class="pro_detail">
                                        <div class="pro_name">{{remover_item.name}}</div>
                                        <div class="pro_ing"><span>产品类型:</span><span class="ing_item">{{remover_item.type}}</span></div>
                                        <div class="pro_price">参考价格:<span>&yen;{{remover_item.price}}</span></div>
                                    </div>
                                  
                                </li>
                                </ul>

                            </div>
                        </div>
                    </transition>
                 



                </div>

                <!-- 注重保湿 -->
                <div class="inner_down inner_down_second" v-if="focused_idx ==1">
                  <p class="inner_down_sub_text">每天化妆和卸妆会给皮肤带来一定的压力,包括化妆品成分的刺激、卸妆时候的摩擦、脸部油脂被卸掉太多导致保湿力不足等等.所以保湿对于经常化妆的人来说很重要.</p>
                  <div class="water_maintain_result_part">
                    <div class="water_maintain_result_title">我的保湿需求:{{makeupdata.moisturize_demand}}</div>
                    <div class="water_maintain_result"><span>基因结果-保湿能力:{{makeupdata.moisturize_gene == 'excellent' ? '较高' : makeupdata.moisturize_gene == 'middling' ? '中等' : '较低'}}</span></div>
                    <div class="water_maintain_result" v-if="makeupdata.ph_type.length>0"><span>现状结果-肤质:{{makeupdata.ph_type}}</span></div>
                  </div>
                  <div class="makeup_rec_title">保湿产品推荐</div>
                  <ul class="makeup_filter_menu">
                    <li class="makeup_filter_menu_item" :class="filter_menu_type == 'makeup_toner' ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:603 }),{is_access:true,reportEvent_page_id:603,reportEvent_page_name:'经常化妆 - 注重保湿 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),filterMakeupPro('makeup_toner')">护肤水</li>
                    <li class="makeup_filter_menu_item" :class="filter_menu_type == 'makeup_serum' ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:603 }),{is_access:true,reportEvent_page_id:603,reportEvent_page_name:'经常化妆 - 注重保湿 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),filterMakeupPro('makeup_serum')">精华</li>
                    <li class="makeup_filter_menu_item" :class="filter_menu_type == 'makeup_mask' ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:603 }),{is_access:true,reportEvent_page_id:603,reportEvent_page_name:'经常化妆 - 注重保湿 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),filterMakeupPro('makeup_mask')">面膜</li>
                    <li class="makeup_filter_menu_item" :class="filter_menu_type == 'makeup_cream' ? 'now' : ''" @click="($parent.trackLog((actParams = { query: $route.query, pageid:603 }),{is_access:true,reportEvent_page_id:603,reportEvent_page_name:'经常化妆 - 注重保湿 - 产品列表',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'场景护肤',reportEvent_third_module:'经常化妆'})),filterMakeupPro('makeup_cream')">乳霜</li>
                  </ul>
                   
                   <!-- 推荐产品 -->
                  <ul class="makeup_rec_pro_list">
                      <li class="makeup_rec_pro" v-for="(maintain_item,maintain_idx) in water_maintain_pro" :key="maintain_idx">
                          <div class="makeup_rec_pro_check_btn" v-if="maintain_item.uniskin_goods_id" @click="$parent.goMallDetail(maintain_item.uniskin_goods_id)">
                              <span class="makeup_rec_pro_check_text">去购买</span>
                              <img src="../assets/images/arrow_right_d.svg" class="makeup_rec_pro_check_icon" alt="">
                          </div>         
                          <img v-lazy="maintain_item.img" :key="maintain_item.img" class="pro_pic" alt="">
                          <div class="pro_detail">
                              <div class="pro_name">{{maintain_item.name}}</div>
                              <div class="pro_ing"><span>产品类型:</span><span class="ing_item">{{maintain_item.type}}</span></div>
                              <div class="pro_price">参考价格:{{maintain_item.price}}</div>
                          </div>
                      </li>
                      <!-- <li class="makeup_rec_pro">
                          <div class="makeup_rec_pro_check_btn">
                              <span class="makeup_rec_pro_check_text">去购买</span>
                              <img src="../assets/images/arrow_right_d.svg" class="makeup_rec_pro_check_icon" alt="">
                          </div>         
                          <img src="../assets/images/Lotion.png" class="pro_pic" alt="">
                          <div class="pro_detail">
                              <div class="pro_name">洗颜专科</div>
                              <div class="pro_ing"><span>功效:</span><span class="ing_item">清洁</span></div>
                              <div class="pro_price">参考价格:180元/100g</div>
                          </div>
                      </li> -->
                  </ul>               

                </div>

                <!-- 更多建议 -->
                <div class="inner_down inner_down_third" v-if="focused_idx == 2">
                  <div class="makeup_more_sug">
                    <img src="../assets/images/makeup_no_mask.png" class="makeup_more_sug_pic" alt="">
                    <div class="makeup_more_sug_info">
                      <div class="makeup_more_sug_info_title">上妆前不需要敷面膜</div>
                      <p class="makeup_more_sug_info_text">刚敷完面膜的皮肤角质细胞含水量较高，比正常状态下更容易受到外界物质的入侵，此时不宜立即上妆，容易损伤皮肤。</p>
                    </div>
                  </div>
                  <div class="makeup_more_sug">
                    <img src="../assets/images/makeup_redo_water.png" class="makeup_more_sug_pic" alt="">
                    <div class="makeup_more_sug_info">
                      <div class="makeup_more_sug_info_title">如何带妆补水</div>
                      <p class="makeup_more_sug_info_text">先用纸巾或者吸油纸轻轻吸去脸上的油，喷保湿喷雾，待喷雾的水珠在脸上停留约半分钟后用纸巾吸去，涂一点乳液，最后再补妆即可。</p>
                    </div>
                  </div>
                  <div class="makeup_more_sug">
                    <img src="../assets/images/makeup_redo_suncream.png" class="makeup_more_sug_pic" alt="">
                    <div class="makeup_more_sug_info">
                      <div class="makeup_more_sug_info_title">上妆后如何补涂防晒</div>
                      <p class="makeup_more_sug_info_text">方法一：用带防晒的气垫补妆，顺便补了防晒，但是气垫的防晒效果是有限的；<br>方法二：先用上述方法补水，再补涂防晒霜，等几分钟防晒霜成膜后，再补妆即可。</p>
                    </div>
                  </div>
                  <div class="makeup_more_sug">
                    <img src="../assets/images/makeup_skip.png" class="makeup_more_sug_pic" alt="">
                    <div class="makeup_more_sug_info">
                      <div class="makeup_more_sug_info_title">每周一两天不化妆</div>
                      <p class="makeup_more_sug_info_text">化妆品中的香精和色素对皮肤多少具有一定刺激性，再加上频繁地上妆卸妆，皮肤屏障难免受损。建议每周最好有一两天不化妆，给皮肤一个休息恢复的机会。</p>
                    </div>
                  </div>
           
                </div>

		
		</div>

 
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
import { setTimeout } from 'timers';
var wx = require("weixin-js-sdk");
export default {
  name: "ScenarioMakeup",
  data() {
    return {
      isload: false,
      focused_idx:0,
      focused_left:0,
      focused_width:0,
      triangle_left:30,  //成分详情icon
      in_weapp: false, //是否在小程序
      makeupdata:null,
      show_makeup_remover:false,  //卸妆产品介绍弹窗
      show_reclean:false,  //二次清洁弹窗
      show_prevent_acne:false,  //预防致痘
      show_layer:false,
      show_oth_pro:false,  //展示其他产品弹窗
      total_makeup_pro:null,  //全部化妆产品
      makeup_remover_pro:null,  //卸妆产品类型
      water_maintain_pro:null,  //注重保湿产品
      filter_menu_type:"makeup_toner" //注重保湿产品类型
    };
  },

  created() {
    console.log("scenario created", this);
    this.initMakeupGuide();
  },
  mounted() {
        setTimeout(() => {
			this.changeFocusedTab(this.focused_idx);
		}, 500);
      
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
    changeFocusedTab: function(idx) {
			this.focused_idx = idx;
			console.log(271, this.$refs['focused_item_' + idx]);
      setTimeout(
        () => {
          // this.focused_width = this.$refs['focused_item_' + idx].clientWidth;
          this.focused_width = 30;
			    this.focused_left = this.$refs['focused_item_' + idx].offsetLeft;
        }
      )
		
		},
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    filterMakeupPro:function(type){
      let that = this;
      if(type.includes("remover_water")){  //卸妆水/啫喱  卸妆乳 洗卸合一洁面
      console.log(that.total_makeup_pro.filter( (v,i) => {
           return v.type.includes("卸妆水") || v.type.includes("卸妆乳") || v.type.includes("洗卸合一");
          }))
          return that.makeup_remover_pro = that.total_makeup_pro.filter( (v,i) => {
            return v.type.includes("卸妆水") || v.type.includes("卸妆乳") || v.type.includes("洗卸合一");
          })
      }else if(type.includes("remover_oil")){  //卸妆油  卸妆膏
          return that.makeup_remover_pro = that.total_makeup_pro.filter( (v,i) => {
            return v.type.includes("卸妆油") || v.type.includes("卸妆膏");
          })
      }else if(type.includes("remover_eye")){  //眼唇卸妆液
          return that.makeup_remover_pro = that.total_makeup_pro.filter( (v,i) => {
            return v.type.includes("眼唇");
          })
      }else if(type.includes("remover_sensi")){   //敏感肌卸妆  含多种类产品
            return that.makeup_remover_pro = [
              {
                name: "贝德玛 卸妆水粉水舒妍多效洁肤液",
                img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_bioderma.png",
                category: "remover",
                type: "卸妆水/啫喱",
                price: "210元/850ml",
                from_url: "https://detail.tmall.hk/hk/item.htm?spm=a1z10.3-b-s.w4011-22002922165.73.8f334b28cv6M30&id=601077301808&rn=862609bcdcc4fb35e1da3ba1d269d558&abbucket=13&skuId=4205921573148"
                },
                {
                  name: "Alovivi 卸妆水",
                  img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_alovivi.png",
                  category: "remover",
                  type: "卸妆水/啫喱",
                  price: "89元/500ml",
                  from_url: "https://detail.tmall.com/item.htm?spm=a1z10.5-b-s.w4011-21086656625.61.4bb13cd4Hr1qlV&id=564939423136&rn=e29400be90e0af2351e51f79e0547548&abbucket=13&skuId=3737828574974"
                  },
                  {
                    name: "Nursery 柚子卸妆啫喱",
                    img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_nursery_yuzu.png",
                    category: "remover",
                    type: "卸妆水/啫喱",
                    price: "278元/500ml",
                    from_url: "https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.fd931a00o6cVYT&id=544503188367&skuId=4275278959045&user_id=3102580974&cat_id=2&is_b=1&rn=3a09020aeaf34aee8c147baded5e2b7c"
                  },
                  {
                      name: "珂润 润浸保湿卸妆啫喱",
                      img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_curel_gel.png",
                      category: "remover",
                      type: "卸妆水/啫喱",
                      price: "88元/130g",
                      from_url: "https://detail.tmall.hk/hk/item.htm?spm=a220m.1000858.1000725.1.79621cb9foW7lZ&id=551232954218&skuId=3530948407814&standard=1&user_id=2549841410&cat_id=2&is_b=1&rn=65aac56e1fed80415d9f3a3fdb29ad85"
                  },
                  {
                    name: "FANCL 纳米净化卸妆油",
                    img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_fancl_mild_oil.png",
                    category: "remover",
                    type: "卸妆油",
                    price: "228元/120ml",
                    from_url: "https://detail.tmall.hk/hk/item.htm?spm=a220m.1000858.1000725.1.48a862abroH48C&id=532988745404&skuId=3517641864195&standard=1&user_id=2549841410&cat_id=2&is_b=1&rn=41a5e2a124a55738a22483dd43a443ff"
                  },
                  {
                    name: "BOBBI BROWN 清润舒盈洁肤油",
                    img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_bobbi_brown_soothing_oil.png",
                    category: "remover",
                    type: "卸妆油",
                    price: "580元/400ml",
                    from_url: "https://detail.tmall.com/item.htm?spm=a1z10.5-b-s.w4011-14717264322.51.5fe97e02PuMn6J&id=521171395396&rn=b5b0a21d644a36f17f20843655862c82&abbucket=13&skuId=3692977475562"
                  },
                  {
                    name: "倩碧 面部及眼部卸妆霜",
                    img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_clinique_eye.png",
                    category: "remover",
                    type: "卸妆膏",
                    price: "260元/125ml",
                    from_url: "https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.770b5e38mZ9Agr&id=18284054354&skuId=32892307502&user_id=1653734047&cat_id=2&is_b=1&rn=584294f448aa48432effb2af606fa6c2"
                  },
                  {
                    name: "Darphin 玫瑰木芳香按摩洁面膏",
                    img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_darphin.png",
                    category: "remover",
                    type: "卸妆膏",
                    price: "340元/40ml",
                    from_url: "https://detail.tmall.com/item.htm?spm=a1z10.5-b-s.w4011-18268457444.62.5ca05a40Czd9XH&id=563895257576&rn=168ddfa53a23ca6cc4b64fec2a3e2b29&abbucket=13"
                  },
                  {
                    name: "欧缇丽 温和卸妆乳",
                    img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_caudalie_gentle.png",
                    category: "remover",
                    type: "卸妆乳",
                    price: "180元/200ml",
                    from_url: "https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.755a4579IPHLoa&id=533060994992&skuId=3180696361005&user_id=2468809135&cat_id=2&is_b=1&rn=04276a004b1ae1b149d77349755aaf0c"
                  },
                  {
                    name: "宝拉珍选 大地之源洁面凝胶",
                    img: "https://static.inertiabiotech.com/uniskin/reportv3/images/makeup_remover_paulas_choice.png",
                    category: "remover",
                    type: "洗卸合一洗面奶",
                    price: "328元/198ml",
                    from_url: "https://detail.tmall.com/item.htm?spm=a220m.1000858.1000725.1.7e095ae04bkV4j&id=44382694818&skuId=4330712071228&user_id=276449747&cat_id=2&is_b=1&rn=e9387e8f3dbb4595b02606b578adfb7b"
                  }
            ]
      }else if(type.includes("makeup_toner")){  //护肤水
          that.filter_menu_type = 'makeup_toner';
          return that.water_maintain_pro = that.total_makeup_pro.filter( (v,i) => {
            return v.type.includes("护肤水");
          })
      }else if(type.includes("makeup_serum")){  //精华
          that.filter_menu_type = 'makeup_serum';
          return that.water_maintain_pro = that.total_makeup_pro.filter( (v,i) => {
            return v.type.includes("精华");
          })
      }else if(type.includes("makeup_mask")){  //面膜
          that.filter_menu_type = 'makeup_mask';
          return that.water_maintain_pro = that.total_makeup_pro.filter( (v,i) => {
            return v.type.includes("面膜");
          })
      }else if(type.includes("makeup_cream")){  //乳霜
          that.filter_menu_type = 'makeup_cream';
          return that.water_maintain_pro = that.total_makeup_pro.filter( (v,i) => {
            return v.type.includes("乳霜");
          })
      }
    },
    initMakeupGuide: function() {
      let that = this;
      var local_makeup_guide = JSON.parse(localStorage.getItem("local_makeup_guide"));
      if (local_makeup_guide) {
        afterMakeupGuide(local_makeup_guide);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/report199_ex1/getMakeupInfo"
          )
          .then(json => {
            console.log(json);
            afterMakeupGuide(json);
            // localStorage.setItem("local_makeup_guide",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterMakeupGuide(guidedata) {
        if (guidedata.code == 0) {
          that.isload = true;
          that.makeupdata = guidedata.data;
          that.total_makeup_pro = guidedata.data.goods;
          that.filterMakeupPro('makeup_toner');  //获取注重保湿护肤水对应产品
          console.log('water_maintain_pro',that.water_maintain_pro)

        }
      }
    },
    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";
//其他产品弹窗
.oth_rec_layer{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,0.2);
    .layer_inner{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width:690/50rem;
        height:1033/50rem;
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        box-sizing:border-box;
        padding:45/50rem 20/50rem 45/50rem 0;
        .close_icon{
            position:absolute;
            top:52/50rem;
            right:30/50rem;
            width:30/50rem;
            height:30/50rem;
        }
        .layer_title{
            padding:0 0 60/50rem 30/50rem;
            font-size:44/50rem;
            line-height:1em;
            font-weight:bold;
        }
    }
}
.layer_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .layer_pro_check_icon{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
        width:27/50rem;
        height:27/50rem;
    }
    .layer_pro_check_btn{
        position:absolute;
        right:0;
        top:35%;
        transform:translateY(-50%);
         z-index:999;
        width:14/50rem;
        height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            .align-self_center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-detail;
            padding-right:30/50rem;
            white-space:nowrap;
        }
        img{
            .align-self_center;
            width:27/50rem;
            height:27/50rem;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_flex-start;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:16/50rem 50/50rem 55/50rem 0;
        margin-bottom:29/50rem;
        width:494/50rem;
        // border-bottom:1px solid @font-c-detail;
        .border-bottom;
        .pro_name{
            font-size:30/50rem;
            line-height:1.1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
}
.layer_pro_list{
    height:863/50rem;
    -webkit-overflow-y:scroll;
    overflow-y:scroll;
    box-sizing:border-box;
}
.layer_pro_list .layer_pro:last-child{
    .pro_detail{
        // border-bottom:1px solid transparent;
        .border-bottom-transparent;
    }
}

.guide_inner{
    background:@bg_c_m;
    padding:0 0 169/50rem;
}
.back_btn{
    position:fixed;
    top:0.6rem;
    left:0;
    width:2.36rem;
    height:1.08rem;
    z-index:888;
}
.inner_up{
    padding:106/50rem 30/50rem 0;
    background:@font-c-f;
    .shadow;
    .guide_title{
      position:relative;
        padding-bottom:86/50rem;
        font-size:44/50rem;
        font-weight:bold;
        line-height:1em;
        text-align:center;
        color:@font-c-3;

    }
    .detail_menu {
    position:relative;
    box-sizing: border-box;
    // .shadow;
    // padding: 81/50rem 30/50rem 0/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .menu_item {
      padding-bottom: 15/50rem;
      margin-right:50/50rem;
      .align-items_flex-end;
      .flex_0;
    //   width: 33.33%;
      font-size: 28/50rem;
      line-height: 1em;
      text-align: center;
      color: @font-c-3;
      border-bottom: 3px solid transparent;
      &.now {
        font-size: 34/50rem;
        font-weight: bold;
        color:@font-c-detail;
        // border-bottom: 3px solid #f099a6;
      }
    }
  }
    .bg_div{
    position:absolute;
    bottom:0;
    height:3px;
    width:60/50rem;
    background:#f099a6;
    -webkit-transition:left 0.5s;
    transition:left 0.5s;
    }
}
.inner_down{
    padding:58/50rem 30/50rem 147/50rem;
}
//特征分析
.inner_down_first{
    padding:58/50rem 30/50rem 147/50rem;
    .inner_down_title{
        padding-bottom:21/50rem;
        line-height:1em;
        font-size:30/50rem;
        line-height:1em;
        color:@font-c-3;
        font-weight:bold;
    }
    .makeup_item{
        .border-radius(14/50rem);
        .shadow;
        background:@bg_c_l;
        padding:43/50rem 30/50rem 26/50rem;
        margin-bottom:30/50rem;
        .makeup_item_title{
            padding-bottom:20/50rem;
            .display_flex;
            .flex-wrap_nowrap;
            .justify-content_flex-start;
            .makeup_item_title_text{
              .align-self_center;
                font-size:30/50rem;
                line-height:1.1em;
                color:@font-c-3;
                font-weight:bold;
                border-bottom:2px solid #f99d9b;
            }
            .makeup_item_title_mark{
              .align-self_center;
              margin-left:14/50rem;
              padding:7/50rem 18/50rem;
              .border-radius(23/50rem);
              background:#ffb37e;
              color:@font-c-f;
              font-size:22/50rem;
              line-height:1em;
            }
        }
        .makeup_item_text{
          padding-bottom:16/50rem;
          font-size:24/50rem;
          line-height:30/50rem;
          color:@font-c-6;
        }
        .makeup_item_summary{
          position:relative;
          padding:0 0 16/50rem 40/50rem;
          font-size:24/50rem;
          line-height:1.2em;
          color:@font-c-detail;
          &::before{
            content:"";
            position:absolute;
            top:5/50rem;
            left:19/50rem;
            width:10px;
            height:10px;
            -webkit-transform:scale(0.5);
            transform:scale(0.5);
            .border-radius(50%);
            background:@font-c-0;

          }
        }
        .makeup_item_check_btn{
          padding-top:5/50rem;
          .display_flex;
          .flex-wrap_nowrap;
          .justify-content_flex-end;
          span{
            padding:12/50rem 30/50rem;
            text-align:center;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-3;
            .border-1px;
          }
        }
    }
    .makeup_item_result_part{
      margin:8/50rem 0 25/50rem;
      .border-radius(14/50rem);
      .gradient(to right,#bffcd7,#66d1c0);
      padding:32/50rem 0 22/50rem;
      .makeup_item_result_part_title{
        padding-bottom:21/50rem;
        text-align:center;
        font-size:28/50rem;
        line-height:1em;
        color:@font-c-f;
      }
      .makeup_item_result_part_desc{
        padding-bottom:13/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-center;
        span{
          .align-self_center;
          font-size:24/50rem;
          line-height:1em;
          color:@font-c-f;
        }
        &::before{
          content:"";
          width:10px;
          height:10px;
          .border-radius(50%);
          background:@font-c-f;
          -webkit-transform:scale(0.5);
          transform:scale(0.5);
        }
      }
    }
    .makeup_related_qus_ul{
      padding:38/50rem 0 0;
      .makeup_related_qus{
        margin-bottom:30/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        span{
          .align-self_center;
          font-size:30/50rem;
          line-height:1.1em;
          color:@font-c-3;
          .border-bottom;
        }
        &::before{
          content:"";
          display:block;
          .align-self_center;
          width:10px;
          height:10px;
          .border-radius(50%);
          background:@font-c-0;
          -webkit-transform:scale(0.5);
          transform:scale(0.5);
          margin-right:10/50rem;
        }
      }
    }
    .makeup_remover_desc_layer{
      position:fixed;
      width:100%;
      height:100%;
      top:0;
      left:0;
      background:rgba(0,0,0,0.3);
      //卸妆产品的种类弹窗
      .makeup_remover_desc_layer_inner{
        box-sizing:border-box;
        position:absolute;
        width:596/50rem;
        height:775/50rem;
        top:45%;
        left:50%;
        -webkit-transform:translate(-50%,-50%);
        transform:translate(-50%,-50%);
        .border-radius(14/50rem);
        .shadow;
        background:@font-c-f;
        padding:73/50rem 30/50rem;
          .makeup_remover_desc_close_btn{
          position:absolute;
          top:30/50rem;
          right:30/50rem;
          width:30/50rem;
          height:30/50rem;
        }
        .makeup_remover_desc_layer_title{
          .display_flex;
          .flex-wrap_nowrap;
          .justify-content_flex-start;
          span{
            font-size:30/50rem;
            line-height:1.1em;
            font-weight:bold;
            color:@font-c-3;
            border-bottom:1px solid @font-c-3;
          }
        }
        .makeup_remover_desc_layer_info{
          padding-bottom:73/50rem;
          box-sizing:border-box;
          height:600/50rem;
          -webkit-overflow-y:scroll;
          overflow-y:scroll;
        }
        .makeup_layer_desc_layer_info_title{
          padding:36/50rem 0 7/50rem;
          .display_flex;
          .flex-wrap_nowrap;
          .justify-content_flex-justify;
          .makeup_layer_info_title_name{
            .align-self_flex-end;
            font-size:28/50rem;
            line-height:1em;
            color:@font-c-detail;
          }
          .makeup_layer_info_title_effect{
            .align-self_flex-end;
            font-size:22/50rem;
            line-height:1em;
            color:@font-c-9;
          }
        }
        .makeup_layer_desc_layer_info_explain{
          font-size:22/50rem;
          line-height:28/50rem;
          color:@font-c-9;
        }
      }

      //是否需要二次清洁弹窗
      .makeup_reclean_layer_inner,.makeup_prevent_acne_layer_inner{
        box-sizing:border-box;
        .border-radius(14/50rem);
        .shadow;
        background:@font-c-f;
        position:absolute;
        top:50%;
        left:50%;
        -webkit-transform:translate(-50%,-50%);
        transform:translate(-50%,-50%);
        width:596/50rem;
        padding:73/50rem 30/50rem 69/50rem;
      }
      .makeup_reclean_layer_close_btn,.makeup_prevent_acne_layer_close_btn{
        position:absolute;
        width:30/50rem;
        height:30/50rem;
        top:30/50rem;
        right:30/50rem;
      }
      .makeup_reclean_layer_title,.makeup_prevent_acne_layer_title{
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        span{
          font-size:30/50rem;
          line-height:1.1em;
          font-weight:bold;
          color:@font-c-3;
          border-bottom:1px solid @font-c-3;
        }
      }
      .makeup_reclean_layer_text,.makeup_prevent_acne_layer_text{
        padding-top:26/50rem;
        font-size:26/50rem;
        line-height:36/50rem;
        color:@font-c-6;
      }


      //如何避免卸妆致痘弹窗

    }
}

//产品推荐
.inner_down_second{
  padding:39/50rem 30/50rem 147/50rem;
  .inner_down_sub_text{
    padding-bottom:35/50rem;
    font-size:24/50rem;
    line-height:28/50rem;
    color:@font-c-3;
  }
  .water_maintain_result_part{
    .border-radius(14/50rem);
    .shadow;
    .gradient(to right,#9ee7fa,#5ea7e0);
    padding:40/50rem 0 33/50rem;
    .water_maintain_result_title{
      text-align:center;
      padding-bottom:30/50rem;
      font-size:32/50rem;
      line-height:1em;
      font-weight:bold;
      color:@font-c-f;
    }
    .water_maintain_result{
      padding-bottom:17/50rem;
      padding-left:174/50rem;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      span{
        .align-self_center;
        font-size:28/50rem;
        line-height:1.1em;
        border-bottom:1px solid @font-c-f;
        color:@font-c-f;
      }
      &::before{
        content:"";
        display:block;
        width:10px;
        height:10px;
        .border-radius(50%);
        background:@font-c-f;
        -webkit-transform:scale(0.5);
        transform:scale(0.5);
        .align-self_center;
      }
    }
  }
  .makeup_rec_pro{
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    position:relative;
    .makeup_rec_pro_check_btn{
        position:absolute;
        right:0;
        top:50%;
        transform:translateY(-50%);
        z-index:999;
        // width:27/50rem;
        // height:27/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-end;
        span{
            font-size:24/50rem;
            white-space:nowrap;
            line-height:1em;
            color:#f99d9b;
            .align-self_center;
        }
        .makeup_rec_pro_check_icon{
            margin-left:10/50rem;
            width:27/50rem;
            height:27/50rem;
            .align-self_center;
        }
    }
    .pro_pic,.pro_detail{
        .align-self_center;
    }
    .pro_pic{
        width:163/50rem;
    }
    .pro_detail{
        padding:51/50rem 50/50rem 44/50rem 0;
        // margin-bottom:29/50rem;
        width:494/50rem;
        // border-bottom:1px solid @font-c-detail;
        .border-bottom;
        .pro_name{
            font-size:30/50rem;
            line-height:1em;
            color:@font-c-3;
            padding-bottom:23/50rem;
        }
        .pro_ing{
            .display_flex;
            .justify-content_flex-start;
            .flex-wrap_wrap;
            span{
                .flex_0;
                font-size:24/50rem;
                line-height:1.1em;
                color:@font-c-9;
                &.ing_item{
                    padding-right:20/50rem;
                }
            }
            
        }
        .pro_price{
            padding-top:16/50rem;
            font-size:24/50rem;
            line-height:1em;
            color:@font-c-9;
        }
    }
  }
  .makeup_rec_pro_list{
    box-sizing:border-box;
    margin-bottom:147/50rem;
    padding-right:20/50rem;
    // background:@bg_c_l;
    background:#fff;
    .border-radius(14/50rem);
    .shadow;
  }
  .makeup_rec_pro_list .makeup_rec_pro:last-child{
      .pro_detail{
          // border-bottom:1px solid transparent;
          .border-bottom-transparent;
      }
  }
  .makeup_rec_title{
    padding:60/50rem 0 38/50rem;
    font-size:28/50rem;
    line-height:1em;
    color:@font-c-3;
    font-weight:bold;
  }
  .makeup_filter_menu{
    padding-bottom:30/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-start;
    .makeup_filter_menu_item{
      box-sizing:border-box;
      margin-right:30/50rem;
      font-size:28/50rem;
      line-height:1em;
      color:@font-c-detail;
      padding:13/50rem 28/50rem;
      .border-radius(34/50rem);
      // .border-1px-34;
      border:1px solid @font-c-detail;
      &.now{
        color:@font-c-f;
        background:@font-c-detail;

      }
    }
  }

}

//使用建议
.inner_down_third{
  padding:56/50rem 30/50rem 225/50rem;
  .makeup_more_sug{
    padding-bottom:40/50rem;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .makeup_more_sug_pic{
      width:140/50rem;
      height:140/50rem;
      .border-radius(14/50rem);
      .shadow;
      background:#fcfcfc;
    }
    .makeup_more_sug_info{
      padding-top:7/50rem;
      width:525/50rem;
      .makeup_more_sug_info_title{
        padding-bottom:11/50rem;
        font-size:30/50rem;
        line-height:1em;
        font-weight:bold;
        color:@font-c-3;
      }
      .makeup_more_sug_info_text{
        font-size:24/50rem;
        line-height:30/50rem;
        color:@font-c-6;
      }
    }
  }
}


</style>
